import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { logger } from "@/lib/utils/logger";
import { t } from "@/lib/i18n";
import { useLocale } from "@/hooks/use-locale";

const NotFound = () => {
  useLocale(); // re-render on language change
  const location = useLocation();

  useEffect(() => {
    logger.warn("404 - route not found", { path: location.pathname });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-foreground">404</h1>
        <p className="text-xl text-muted-foreground">{t("nf.notfound")}</p>
        <a
          href="/"
          className="inline-flex items-center justify-center px-6 py-2 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
        >
          {t("nf.home")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
